const distributionRoutes = [
  {
    path: "/accountList",
    name: "accountList",
    component: () => import("@/views/distribute/accountList.vue"),
    meta: {
      title: "账户列表",
      // keepAlive: true
    },
  },
  {
    path: "/budgetDetail",
    name: "budgetDetail",
    component: () => import("@/views/distribute/budgetDetail.vue"),
    meta: {
      title: "收支明细",
      // keepAlive: true
    },
  },
  {
    path: "/posterList",
    name: "posterList",
    component: () => import("@/views/distribute/posterList.vue"),
    meta: {
      title: "海报列表",
      keepAlive: true,
    },
  },
  {
    path: "/posterAdd",
    name: "posterAdd",
    component: () => import("@/views/distribute/posterAdd.vue"),
    meta: {
      title: "海报添加",
    },
  },
  {
    path: "/scaleSetting",
    name: "scaleSetting",
    component: () => import("@/views/distribute/scaleSetting.vue"),
    meta: {
      title: "比例设置",
    },
  },
];

export default distributionRoutes;
